module.exports = __webpack_public_path__ + "img/Phone.753b199.svg";